/**
 * Analytics event names used throughout the application
 */

// AI Review Feedback Events
export const AI_REVIEW_FEEDBACK_VOTE_EVENT = 'ai_review_feedback_vote';

// SAML SSO recovery funnel events
export const SAML_SSO_ANALYTICS_EVENTS = {
  DETECTED: 'saml_sso_detected',
  RECOVERY_SHOWN: 'saml_sso_recovery_shown',
  AUTHORIZE_CLICKED: 'saml_sso_authorize_clicked',
  AUTHORIZATION_RETURN_REFRESH_TRIGGERED: 'saml_sso_authorization_return_refresh_triggered',
  REFRESH_CLICKED: 'saml_sso_refresh_clicked',
  REFRESH_SUCCESS: 'saml_sso_refresh_success',
  REFRESH_FAILED: 'saml_sso_refresh_failed',
  REFRESH_STILL_BLOCKED: 'saml_sso_refresh_still_blocked',
} as const;
